import React from 'react';
import PropTypes from 'prop-types';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import TagList from 'shared/components/TagList/TagList';
import s from './SidebarFilters.css';

class SidebarFilters extends React.Component {
  static propTypes = {
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        slug: PropTypes.string,
        count: PropTypes.number,
      }),
    ).isRequired,
    activeTag: PropTypes.string,
    currentRubric: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
    query: PropTypes.objectOf(PropTypes.string).isRequired,
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    activeTag: null,
  };

  render() {
    const { tags, activeTag, url, query, currentRubric, intl } = this.props;

    if (!tags.length) {
      return null;
    }

    return (
      <div className={s.root}>
        <h4 className={s.title}>
          <FormattedMessage id="Фильтр" />
        </h4>

        <TagList
          className={s.list}
          max={6}
          title={intl.formatMessage({ id: 'Основные темы' })}
          tags={tags}
          activeTag={activeTag}
          url={url}
          query={query}
          currentRubric={currentRubric}
        />
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(SidebarFilters));



// WEBPACK FOOTER //
// ./src/desktop/routes/journal/components/SidebarFilters/SidebarFilters.js